import { LoadingPlayground } from "../LoadingPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const loadingEntries: PlaygroundComponentEntry[] = [
    {
        id: "loading",
        label: "Loading",
        description: "Loaders, skeletons, and loading buttons.",
        group: "components",
        render: () => <LoadingPlayground />,
    },
];
